import React, { useState, useEffect } from 'react';
import { postAPI } from '../../../app/api';
import arrawLeft from "../../../theme/assets/images/icon/arrow-left.svg"
import missionImg from "../../../assets/img/tentphoto.webp"
const { REACT_APP_BRANDURL } = process.env;

export default function OurMission() {
    const [missionData, setMissionData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchMissionData();
    }, []);

    const fetchMissionData = async () => {
        try {
            setLoading(true);
            const response = await postAPI('about-us/getBySection', { 
                page: 'ABOUT', 
                section_name: 'Our Mission' 
            });
            if (response?.status === 1 && response?.data) {
                setMissionData(response.data);
            }
        } catch (error) {
            console.error('Error fetching mission data:', error);
        } finally {
            setLoading(false);
        }
    };

    // if (loading) {
    //     return (
    //         <div className="text-center py-5">
    //             <div className="spinner-border" role="status">
    //                 <span className="visually-hidden">Loading...</span>
    //             </div>
    //         </div>
    //     );
    // }

    // if (!missionData) {
    //     return null;
    // }

    return (
        <section className='mission'>
            <div className='container'>
                <div className='row justify-content-between'>
                    <div className='col-lg-5 order-1 order-lg-2 mb-lg-0 mb-3 text-md-start text-center'>
                        <figure><img src={missionImg} className='img-fluid' alt="Our Mission" /></figure>
                    </div>
                    <div className='col-lg-7 order-2 order-lg-1'>
                        <h3>Our Preamble</h3>
                        <p>Ex-Students of Bengal Engineering College hereinafter referred to as B E College, residing in Bidhannagar (Salt Lake), adjacent to the City of Kolkata, have formed an association under the name “B E College Ex-Students Club” to enhance fostering the spirit of amity and to satisfy the natural needs of the alumni of Bengal Engineering College, and their families by providing a forum for social, cultural, recreational, intellectual and professional interchange and interaction. The Club was formally inaugurated on Sunday, the 8th June, 1986 in which more than 100 Alumni of B E College were present.</p>
                        {/* <p><strong>Mission Objectives:</strong></p>
                        <ul>
                            <li>Foster lifelong bonds among alumni through social and cultural engagement.</li>
                            <li>Promote professional collaboration, mentorship, and networking opportunities.</li>
                            <li>Organize seminars, workshops, and community programs for collective growth.</li>
                            <li>Encourage participation of members and families in club initiatives.</li>
                            <li>Support charitable and educational causes that benefit society.</li>
                        </ul> */}
                        {/* <div dangerouslySetInnerHTML={{ __html: missionData.content }} /> */}
                    </div>
                </div>
            </div>
        </section>
    )
}
